module.exports = {

    setNewUrl: (url, name) => {
        history.pushState([], name || '', url || '/');
    },

    getCurParam: (param) => {
        return decodeURIComponent(getParamInner(window.location.search) || getParamInner(window.location.hash));

        function getParamInner(line) {
            let result = new RegExp('[?#&]' + param + '=([^&$]*)').exec(line);
            return result ? result[1] : '';
        }
    },

    setCurParam: (param, val) => {
        val = encodeURIComponent(val);

        let url = window.location.href;

        let newUrl = url
            .replace(new RegExp('([?&#])[?&#]*' + param + '=[^&$]*[&]?'), '$1')
            .replace(/[?#&]+$/, '');

        if (val) {
            newUrl += ~newUrl.indexOf('#') ? '&' : '#';
            newUrl += param + '=' + val;
        }

        module.exports.setNewUrl(newUrl);
    }

};